module.exports = __webpack_public_path__ + "static/media/frames-4.9fea1412.jpg";